import { EditIncentivesMarketSharePurchaseContractTemplateModalContextType } from '../types/EditIncentivesMarketSharePurchaseContractTemplateModalContextType';

export const editIncentivesMarketSharePurchaseContractTemplateModalInitValue: EditIncentivesMarketSharePurchaseContractTemplateModalContextType =
  {
    data: {
      societyId: '',
      documentId: null,
      contractText: '',
      isLoading: false,
      isSaving: false,
      loadError: false,
      editorInstance: null,
    },
    actions: {
      handleCloseModal: () => {},
      setContractText: () => {},
      insertVariable: () => {},
      setEditorInstance: () => {},
      onEditorChange: () => {},
      handleSave: async () => {},
    },
  };
